export default __webpack_public_path__ + "static/media/close.96bda371.svg";